import {
	DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK,
	DEVOPS_GET_TO_KNOW_JIRA_TASK,
	DEVOPS_NAVIGATE_YOUR_TOOLS_TASK,
	DEVOPS_CAPTURE_INTEGRATIONS_TASK,
	DEVOPS_CREATE_AUTOMATION_RULES_TASK,
	DEVOPS_INVITE_TEAMMATES_TASK,
	DEVOPS_FIND_HELP_TASK,
} from '../../../../common/constants.tsx';
import type { Cards, TaskList } from '../../../../common/types.tsx';
import { messages } from './messages.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Experiment: Record<string, any> = {};

export const TASK_LIST: TaskList = Object.freeze({
	root: {
		title: messages.rootTitle,
		items: [
			DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK,
			DEVOPS_GET_TO_KNOW_JIRA_TASK,
			DEVOPS_NAVIGATE_YOUR_TOOLS_TASK,
			DEVOPS_CAPTURE_INTEGRATIONS_TASK,
			DEVOPS_CREATE_AUTOMATION_RULES_TASK,
			DEVOPS_INVITE_TEAMMATES_TASK,
			DEVOPS_FIND_HELP_TASK,
		],
	},
});

// https://hello.atlassian.net/wiki/spaces/agile/pages/1093679513/Documentation+QS+Card+manager
export const TASK_VARIANTS: Cards = {
	[DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK]: {
		position: { default: 0 },
		visibility: { default: true },
	},
	[DEVOPS_GET_TO_KNOW_JIRA_TASK]: {
		position: { default: 100 },
		visibility: { default: true },
	},
	[DEVOPS_NAVIGATE_YOUR_TOOLS_TASK]: {
		position: { default: 200 },
		visibility: { default: true },
	},
	[DEVOPS_CAPTURE_INTEGRATIONS_TASK]: {
		position: { default: 300 },
		visibility: {
			default: true,
		},
	},
	[DEVOPS_CREATE_AUTOMATION_RULES_TASK]: {
		position: { default: 400 },
		visibility: { default: true },
	},
	[DEVOPS_INVITE_TEAMMATES_TASK]: {
		position: { default: 500 },
		visibility: { default: true },
	},
	[DEVOPS_FIND_HELP_TASK]: {
		position: { default: 600 },
		visibility: { default: true },
	},
};
